import { render, staticRenderFns } from "./ReportStatusItemComponent.vue?vue&type=template&id=a24800d6&scoped=true&"
import script from "./ReportStatusItemComponent.vue?vue&type=script&lang=js&"
export * from "./ReportStatusItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24800d6",
  null
  
)

export default component.exports